import type { FC } from 'react';
import { QProgress, QText } from '../../QAtoms';
import { QStack } from '../../QLayouts';
import { QIcon } from '../../QIcons';
import { useLibraryTranslation } from '../../i18n';

export const UploadInProgress: FC = () => {
  const { t } = useLibraryTranslation();
  return (
    <QStack alignItems="center" spacing="10px">
      <QStack direction="row" alignItems="center">
        <QIcon iconName="Upload" color="blue.500" />
        <QText fontSize="sm" color="blue.500">
          {t('fileInput.uploadingFile')}
        </QText>
      </QStack>
      <QProgress width="300px" colorScheme="blue" size="xs" isIndeterminate />
    </QStack>
  );
};
